(function () {
  const SLIDER_SELECTOR = '[data-collection-list-slider]';

  function initSlider(sliderEl) {
    if (typeof Swiper === 'undefined') return;
    if (sliderEl.dataset.collectionListInit === 'true') return;

    let options = {};

    try {
      options = JSON.parse(sliderEl.dataset.sliderOptions || '{}');
    } catch (error) {
      console.warn('Collection list slider: options parse error', error);
    }

    sliderEl.dataset.collectionListInit = 'true';
    sliderEl.collectionListSwiper = new Swiper(sliderEl, options);
  }

  function initAll(root) {
    const scope = root || document;
    scope.querySelectorAll(SLIDER_SELECTOR).forEach(initSlider);
  }

  function destroyAll(root) {
    if (!root) return;

    root.querySelectorAll(SLIDER_SELECTOR).forEach(function (sliderEl) {
      if (sliderEl.collectionListSwiper) {
        sliderEl.collectionListSwiper.destroy(true, true);
        sliderEl.collectionListSwiper = null;
      }

      delete sliderEl.dataset.collectionListInit;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyAll(event.target);
  });
})();
